// @flow
import { SERVER_ADDRESS, fetchPost } from '../util/actionsUtil';

export const FETCH_SEARCH_RESULTS_LOADING = 'FETCH_SEARCH_RESULTS_LOADING';
export const FETCH_SEARCH_RESULTS_SUCCESS = 'FETCH_SEARCH_RESULTS_SUCCESS';
export const FETCH_SEARCH_RESULTS_ERROR = 'FETCH_SEARCH_RESULTS_ERROR';
export const FETCH_SEARCH_RESULTS_ADVANCED_LOADING = 'FETCH_SEARCH_RESULTS_ADVANCED_LOADING';
export const FETCH_SEARCH_RESULTS_ADVANCED_SUCCESS = 'FETCH_SEARCH_RESULTS_ADVANCED_SUCCESS';
export const FETCH_SEARCH_RESULTS_ADVANCED_ERROR = 'FETCH_SEARCH_RESULTS_ADVANCED_ERROR';
export const FETCH_SEARCH_RESULTS_FOR_UPDATES_SUCCESS = 'FETCH_SEARCH_RESULTS_FOR_UPDATES_SUCCESS';
export const FETCH_SEARCH_RESULTS_FOR_UPDATES_ADVANCED_SUCCESS = 'FETCH_SEARCH_RESULTS_FOR_UPDATES_ADVANCED_SUCCESS';

export function fetchSearchResults(values: Object) {
  return ((dispatch: Function) => {
    dispatch({
      type: FETCH_SEARCH_RESULTS_LOADING,
    });
    fetchPost(
      `${SERVER_ADDRESS}/search/basic`,
      values,
      (data) => {
        dispatch({
          type: FETCH_SEARCH_RESULTS_SUCCESS,
          data,
        });
      },
      (error) => {
        dispatch({
          type: FETCH_SEARCH_RESULTS_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
  });
}

export function fetchSearchResultsAdvanced(values: Object) {
  return ((dispatch: Function) => {
    dispatch({
      type: FETCH_SEARCH_RESULTS_ADVANCED_LOADING,
    });
    fetchPost(
      `${SERVER_ADDRESS}/search/advanced`,
      values,
      (data) => {
        dispatch({
          type: FETCH_SEARCH_RESULTS_ADVANCED_SUCCESS,
          data,
        });
      },
      (error) => {
        dispatch({
          type: FETCH_SEARCH_RESULTS_ADVANCED_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
  });
}

export function fetchSearchResultsForUpdates(values: Object) {
  return ((dispatch: Function) => {
    dispatch({
      type: FETCH_SEARCH_RESULTS_LOADING,
    });
    fetchPost(
      `${SERVER_ADDRESS}/search/basic`,
      values,
      (data) => {
        dispatch({
          type: FETCH_SEARCH_RESULTS_FOR_UPDATES_SUCCESS,
          data,
        });
      },
      (error) => {
        dispatch({
          type: FETCH_SEARCH_RESULTS_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
  });
}

export function fetchSearchResultsForUpdatesAdvanced(values: Object) {
  return ((dispatch: Function) => {
    dispatch({
      type: FETCH_SEARCH_RESULTS_ADVANCED_LOADING,
    });
    fetchPost(
      `${SERVER_ADDRESS}/search/advanced`,
      values,
      (data) => {
        dispatch({
          type: FETCH_SEARCH_RESULTS_FOR_UPDATES_ADVANCED_SUCCESS,
          data,
        });
      },
      (error) => {
        dispatch({
          type: FETCH_SEARCH_RESULTS_ADVANCED_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
  });
}



// WEBPACK FOOTER //
// ./client/src/actions/searchActions.js